// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__irgdu","title":"ClientReferral_title__3JgXk","itemText":"ClientReferral_itemText__2eJ4q"};